import { createContext, useContext, useState } from "react";
import { useStoreWithEqualityFn } from "zustand/traditional";
import { createEditorStore, EditorProps, EditorState, EditorStore } from "./editorStore";

const EditorStoreContext = createContext<EditorStore | null>(null);

type EditorStoreProviderProps = React.PropsWithChildren<EditorProps>;

const EditorStoreProvider = ({ children, ...props }: EditorStoreProviderProps) => {
  const [store] = useState(() => createEditorStore(props));

  return <EditorStoreContext.Provider value={store}>{children}</EditorStoreContext.Provider>;
};

export function useEditorStoreContext<T>(
  selector: (state: EditorState) => T,
  equalityFn?: (left: T, right: T) => boolean
): T {
  const store = useContext(EditorStoreContext);
  if (!store) throw new Error("Editor store not provided");
  return useStoreWithEqualityFn(store, selector, equalityFn);
}

export default EditorStoreProvider;
